module.exports = __webpack_public_path__ + "static/img/man_glove_4.8267c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_glove_4.png
// module id = H8K0
// module chunks = 0